import {
  AlertTriangle,
  Check,
  CirclePlay,
  Clock,
  Database,
  Loader2,
  PackageCheck,
  Pause,
  X,
} from 'lucide-react'
import { type ComponentProps } from 'react'

import { Badge } from 'slab'
import { type BrokersOperationsBatchStatus } from 'utils/web_api.schemas'

type IconProp = ComponentProps<typeof Badge>['leftIcon']
type BadgeType = ComponentProps<typeof Badge>['type']

const getStatusBadgeMetadata = (
  status: BrokersOperationsBatchStatus
): { type: BadgeType; text: string; leftIcon: IconProp } => {
  // Create spinning loader component for executing status
  const SpinningLoader: IconProp = (props: any) => (
    <Loader2 className='animate-spin' {...props} />
  )

  switch (status) {
    case 'pending':
      return { type: 'slate', text: 'Pending', leftIcon: Clock }
    case 'gathered':
      return { type: 'info', text: 'Gathered', leftIcon: Database }
    case 'prepared':
      return { type: 'caution', text: 'Prepared', leftIcon: PackageCheck }
    case 'executing':
      return { type: 'info', text: 'Executing', leftIcon: SpinningLoader }
    case 'paused':
      return { type: 'caution', text: 'Paused', leftIcon: Pause }
    case 'completed':
      return { type: 'success', text: 'Completed', leftIcon: Check }
    case 'failed':
      return { type: 'critical', text: 'Failed', leftIcon: AlertTriangle }
    case 'canceled':
      return { type: 'slate', text: 'Canceled', leftIcon: X }
    default:
      return { type: 'slate', text: 'Unknown', leftIcon: CirclePlay }
  }
}

type StatusBadgeProps = {
  status: BrokersOperationsBatchStatus
}

export const StatusBadge = ({ status }: StatusBadgeProps) => {
  const { type, text, leftIcon } = getStatusBadgeMetadata(status)

  return (
    <Badge type={type} bordered leftIcon={leftIcon}>
      {text}
    </Badge>
  )
}
